import { combineReducers } from 'redux';

import comment from './comment';

export default combineReducers({ comment });
